export enum ListingOrderBy {
  WEIGHT = 'weight',
  ID = 'id',
  STARTING_BID = 'starting_bid',
  STATE_ID = 'state',
  COUNTY_ID = 'county',
  NET_ACRES = 'net-mineral-acres',
  AVERAGE_MONTHLY_CASH_FLOW = 'cash-flow'
}
